import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, catchError, of } from 'rxjs';
import { StateManager } from '@shared/services/state-manager/state-manager.service';
import { resolvePreferredLanguage } from './translation.initializer';

/** Waits for the saved language file so routed content renders already translated. */
export function preferenceResolver(): Observable<unknown> {
  return inject(TranslateService)
    .use(resolvePreferredLanguage(inject(StateManager)))
    .pipe(catchError(() => of(null)));
}
